import { Input } from "antd"
import { FC, useRef, useEffect } from "react"
import { delayFunction } from "utils/functions";
const { Search } = Input


interface IProps {
  placeholder: string
  searchQuery?: string | null
  initialValue?: string | null
  setSearchQuery: (value: string | null) => void
  style?: any;
}

export const SearchFilter: FC<IProps> = ({placeholder, searchQuery, setSearchQuery, style, initialValue}) => {
  const searchRef = useRef<Input>(null);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = e.target.value

    delayFunction('search-filter', () => {
      setSearchQuery(searchQuery)
    }, 500)
  }

  useEffect(() => {
    if(initialValue) {
      searchRef.current?.setValue(initialValue)
    }
    else {
      searchRef.current?.setValue("")
    }
  }, [initialValue])

  return (
    <Search
      ref={searchRef}
      placeholder={placeholder}
      onSearch={(value: string) => setSearchQuery(value)}
      onChange={handleOnChange}
      value={searchQuery}
      style={style ?? { width: "30%" }}
    />
  )
}
